<div>
	<app-create-employee
		label="Add a real estate agent"
		checkboxLabel="Same as brokerage firm"
		[firstName]="firstName"
		[lastName]="lastName"
		[firm]="brokerage"
		[employee]="brokerage?.broker"
		[required]="required"
		(onSubmit)="onSubmit($event)"
	>
	</app-create-employee>
</div>
